<div class="organization-services-payment-preference-card">
  <div class="organization-services-payment-preference-card__header">
    <span class="organization-services-payment-preference-card__header-title">
      {{ "LABELS.ORGANIZATION_SERVICES_PAYMENT_PREFERENCE" | translate | uppercase }}
    </span>
    <div class="organization-services-payment-preference-card__header-actions" (click)="openPaymentPreferenceEdit()">
      <img src="assets/icons/edit_gray.svg" />
      <span *ngIf="!(isTablet$ | async)">{{ organizationPaymentTypeButtonText | translate }}</span>
    </div>
  </div>
  <div class="organization-services-payment-preference-card__body">
    <div class="organization-services-payment-preference-card__body-left col-lg-8">
      <p class="organization-services-payment-preference-card__payment-type" *ngIf="!isPaymentPreferenceEdit">
        {{ organizationPaymentTypeText | translate }}
      </p>
      <p class="organization-services-payment-preference-card__next-payment-date" *ngIf="!isPaymentPreferenceEdit && isMonthly">
        Next payment {{ monthlyNextPaymentDate }}
      </p>
      <div class="payment-type-select-menu" *ngIf="isPaymentPreferenceEdit">
        <p class="payment-type-select-menu__description">{{ "ORGANIZATION.SERVICE_PAYMENT_PREFERENCE_BLOCK.DESCRIPTION" | translate }}</p>
        <div class="payment-type-select-menu__radio">
          <div
            class="card card-step payment-type-select-menu__payment-type"
            [ngClass]="{
              'is-selected': formGroup?.get('paymentTypePreference').value === false
            }"
          >
            <div class="card-header">
              <app-radio-button
                [id]="'paymentTypePreference-yes'"
                [value]="false"
                [name]="'paymentTypePreference'"
                [control]="formGroup?.get('paymentTypePreference')"
                [label]="'LABELS.INSTANT_PAYMENT' | translate"
              ></app-radio-button>
            </div>
            <div class="card-body px-3">
              <span [innerHTML]="'ORGANIZATION.SERVICE_PAYMENT_PREFERENCE_BLOCK.INSTANT_PAYMENT_HINT' | translate"></span>
            </div>
          </div>

          <div
            class="card card-step payment-type-select-menu__payment-type"
            [ngClass]="{
              'is-selected': formGroup?.get('paymentTypePreference').value
            }"
          >
            <div class="card-header">
              <app-radio-button
                [id]="'paymentTypePreference-no'"
                [value]="true"
                [name]="'paymentTypePreference'"
                [control]="formGroup?.get('paymentTypePreference')"
                [label]="'LABELS.MONTHLY_PAYMENT' | translate"
              ></app-radio-button>
            </div>
            <div class="card-body px-3">
              <span [innerHTML]="'ORGANIZATION.SERVICE_PAYMENT_PREFERENCE_BLOCK.MONTHLY_PAYMENT_HINT' | translate"></span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="organization-services-payment-preference-card__body-right col-4 ml-3" *ngIf="!(isTablet$ | async)">
      <span [innerHTML]="'LABELS.ORGANIZATION_SERVICES_PAYMENT_PREFERENCE_DESCRIPTION' | translate"></span>
    </div>
  </div>

  <div class="organization-services-payment-preference-card__footer" *ngIf="isPaymentPreferenceEdit">
    <button type="button" class="btn btn-outline-bordered btn-square mr-4" (click)="closePaymentPreferenceEdit()">
      {{ "BUTTON.CANCEL" | translate }}
    </button>
    <button
      [disabled]="isSaveChangesDisabled"
      type="button"
      class="organization-services-payment-preference-card__save-btn btn btn-primary btn-square"
      (click)="onSave()"
    >
      {{ "BUTTON.SAVE_CHANGES" | translate }}
    </button>
  </div>
</div>

<custom-modal
  modalClass="change-to-monthly-disclaimer-modal"
  [(open)]="isOpenChangeToMonthlyDisclaimerModal"
  [header]="'LABELS.CHANGE_TO_MONTHLY_PAYMENT'"
>
  <div class="form-row">
    <div class="col">
      <p class="change-to-monthly-disclaimer-modal__description">
        {{ "ORGANIZATION.SERVICE_PAYMENT_PREFERENCE_DISCLAIMER.DESCRIPTION" | translate }}
      </p>
      <ol class="change-to-monthly-disclaimer-modal__instructions">
        <li class="change-to-monthly-disclaimer-modal__instruction" *ngFor="let instruction of changeToMonthlyDisclaimerInsructions">
          {{ instruction }}
        </li>
      </ol>
    </div>
  </div>
  <div class="change-to-monthly-disclaimer-modal__actions">
    <button footer-action type="button" class="btn btn-primary btn-square" (click)="setIsOpenChangeToMonthlyDisclaimerModal(false)">
      {{ "BUTTON.CLOSE" | translate }}
    </button>
  </div>
</custom-modal>
